
import { mapActions } from 'vuex';

import ImgLoader from '@/components/core/img-loader/img-loader.vue';
import DisclaimerPrivacyTerms from '@/components/static/disclaimer-privacy-terms/disclaimer-privacy-terms.vue';
import PrivacyPolicyModal from '@/components/static/privacy-policy-and-terms-modal/privacy-policy-modal.vue';
import TermsModal from '@/components/static/privacy-policy-and-terms-modal/terms-modal.vue';
import { QUIZ_VARIANTS } from '@/modules/tour/domain/tour';

export default {
  components: {
    PrivacyPolicyModal,
    TermsModal,
    DisclaimerPrivacyTerms,
    ImgLoader,
  },
  props: {
    titleHero: {
      type: String,
      default: null,
    },
    landingPage: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getDisclaimerTextPath() {
      const variantMaps = {
        [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_NEW_CHECKOUT]:
          'landingPage.28DayPilatesDisclaimer.secureTextModalPilates28DayChallengeDisclaimer',
        [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_NEW_EMAIL_CONSENT_STEP]:
          'landingPage.28DayPilatesDisclaimer.secureTextModalPilates28DayChallengeDisclaimer',
        [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_GENERIC_US]:
          'landingPage.28DayPilatesDisclaimer.pilatesChallengeCompliantDisclaimer',
        [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_GENERIC_OTHERS]:
          'landingPage.28DayPilatesDisclaimer.pilatesChallengeCompliantDisclaimer',
      };
      return variantMaps[this.getQuizVariant] || variantMaps[QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_NEW_CHECKOUT];
    },
    getImage() {
      const variantMap = {
        default: 'landing-pages/pilates/pilate-challenge.webp',
        [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_LP_NEW_IMAGE_V1]: 'landing-pages/pilates/pilates-challenge-1.webp',
        [QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_LP_NEW_IMAGE_V2]: 'landing-pages/pilates/pilates-challenge-2.webp',
      };

      return variantMap[this.getQuizVariant] || variantMap['default'];
    },
  },
  methods: {
    ...mapActions('quiz', ['pushQuizAnswerToTheStoreAction', 'setDefaultStateValue']),
    handleDefaultState(value) {
      this.pushQuizAnswerToTheStoreAction({ id: 'age', answer: value });
      this.setDefaultStateValue(value);
      this.$router.push('/quiz/start');
    },
    openTermsModal() {
      this.$modal.show('termsModal');
    },
    openPrivacyModal() {
      this.$modal.show('privacyPolicyModal');
    },
  },
};
